/**
 * Tarjeta con cabecera del backoffice. Agrupa una tabla, un grafico o una lista
 * bajo un titulo con su propio `<h2>`.
 */
import type { ReactNode } from 'react';

export interface PanelAdminProps {
  titulo: string;
  bajada?: string;
  /** Etiqueta o boton alineado a la derecha del titulo. */
  extra?: ReactNode;
  /** `plano` cuando el contenido es una tabla que llega hasta el borde. */
  variante?: 'normal' | 'plano';
  children: ReactNode;
}

export function PanelAdmin({
  titulo,
  bajada,
  extra,
  variante = 'normal',
  children,
}: PanelAdminProps) {
  return (
    <section className="panel">
      <div className="panel-cab">
        <div>
          <h2>{titulo}</h2>
          {bajada !== undefined ? <p className="sub">{bajada}</p> : null}
        </div>
        {extra}
      </div>
      <div className={variante === 'plano' ? 'panel-cuerpo plano' : 'panel-cuerpo'}>{children}</div>
    </section>
  );
}
